import styled from 'styled-components';
import Quests from '../../UI/QuestCard';

export const Container = styled.div`
  margin-top: 10px;

  .title {
    display: flex;
    justify-content: space-between;

    @media (max-width: 769px) {
      margin-left: 21px;
    }
  }

  .arrows {
    display: flex;
    align-self: center;
    padding: 0;
    width: 30px;
    justify-content: space-between;
    @media (max-width: 769px) {
      display: none;
    }
  }
  .contentHotQuests {
    width: 100%;
    display: flex;
    align-items: center;
    height: 390px;
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 425px) {
      height: 220px;
    }
  }

  .cards {
    display: flex;
    gap: 20px;

    &:first-child {
      @media (max-width: 769px) {
        margin-left: 21px;
      }
    }

    ::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }

    .card {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      height: 292px;
      width: 235px;
      padding: 0;
      margin: 5px 0 0 10px;
      box-shadow: none;
      border-radius: 22px;

      font-weight: bold;
      font-size: 16px;
      text-align: center;

      cursor: pointer;

      @media (max-width: 425px) {
        width: 152px;
        height: 185px;

        font-size: 12px;
      }

      img {
        width: 230px;
        min-height: 148px;
        max-height: 148px;
        object-fit: cover;
        border-radius: 22px 22px 0 0;
        margin: -8px;
        border: 1px solid;

        @media (max-width: 425px) {
          width: 152px;
          min-height: 100px;
          max-height: 100px;
        }
      }

      span {
        margin: 12px 20px;
        color: #fff;
        @media (max-width: 425px) {
          margin: 5px;
        }
      }

      &:last-child {
        margin-right: 10px;
      }
    }
  }
`;


export const QuestGridCards = styled.div`
  -webkit-tap-highlight-color: transparent;
  display: grid;
  grid-auto-rows: 1fr;

  grid-template-columns: repeat(3, minmax(230px, 1fr));

  @media (max-width: 1090px) {
    grid-template-columns: repeat(2, minmax(230px, 1fr));
  }

  @media (max-width: 570px) {
    grid-template-columns: repeat(2, minmax(155px, 1fr));
  }

  @media (max-width: 374px) {
    grid-template-columns: repeat(1, minmax(155px, 1fr));
  }

  // @media (min-width: 769px) {
  //   &:has(> :last-child:nth-child(1)) {
  //     grid-template-columns: repeat(auto-fit, minmax(232px, 280px));
  //   }

  //   &:has(> :last-child:nth-child(2)) {
  //     grid-template-columns: repeat(auto-fit, minmax(232px, 280px));
  //   }
  // }

  // @media (max-width: 515px) {
  //   grid-template-columns: repeat(auto-fit, minmax(196px, 1fr));
  // }

  // @media (max-width: 515px) {
  //   grid-template-columns: repeat(auto-fit, minmax(196px, 1fr));
  // }

  // @media (max-width: 443px) {
  //   grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  // }

  // @media (max-width: 351px) {
  //   grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  // }

  ${Quests.Container} {
    width: 100%;
  }

  grid-gap: 10px 10px;
  justify-content: start;
  justify-items: center;
  align-items: center;
  width: 100%;
`;
